export const checkWatermark = (
  playerEl: HTMLDivElement,
  watermarkEl: HTMLDivElement,
) => {
  const watermarkInterval = setInterval(() => {
    if (!watermarkEl) return;
    let clonedWatermarkEl = watermarkEl.cloneNode(true);
    clearInterval(watermarkInterval);
    const config = { attributes: true, childList: true, subtree: true };
    const callback: MutationCallback = (mutationList) => {
      mutationList.forEach((mutation) => {
        // 워터마크 삭제 동작 감지
        if (
          mutation.type === 'childList' &&
          Array.from(mutation.removedNodes).includes(watermarkEl)
        ) {
          playerEl.appendChild(clonedWatermarkEl);
          Object.assign(watermarkEl, clonedWatermarkEl);
          clonedWatermarkEl = watermarkEl.cloneNode(true);
        }
      });
    };
    const observer = new MutationObserver(callback);
    observer.observe(playerEl, config);
  }, 500);
};
